import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Button } from '@lt/components';
import { ClearFilter as ClearFilterIcon } from '@lt/components/icons-react/userflow';

interface IFiltersClearButton {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  isMobile?: boolean;
  className?: string;
}

/**
 * Кнопка сброса фильтров
 */
const FiltersClearButton: FC<IFiltersClearButton> = ({
  onClick,
  className,
  isMobile = false,
}) => {
  const { t } = useTranslation();
  return (
    <ClearButton
      className={className}
      functional={isMobile}
      size="flex"
      onClick={onClick}
      isMobile={isMobile}
      offHover
    >
      <Icon $isMobile={isMobile} />
      {isMobile
        ? t('filters.clearbutton.mobile')
        : t('filters.clearbutton.desktop')}
    </ClearButton>
  );
};

const ClearButton = styled(Button)`
  width: inherit;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  min-height: 32px;
  font-size: 14px;
  line-height: 16px;
  background: transparent;
  color: #4d4d4d;
  border-color: #c2c5cc;

  ${({ isMobile }) =>
    isMobile &&
    `
    min-height: unset;
    color: #007aff;
    border: 0;
  `}
`;

const Icon = styled(ClearFilterIcon)<{ $isMobile: boolean }>`
  width: 16px;
  margin-right: 6px;

  stroke: ${({ $isMobile }) => ($isMobile ? '#007aff' : '#919499')};
`;

const FiltersClearButtonStyles = {
  ClearButton,
  Icon,
};

export { FiltersClearButton, FiltersClearButtonStyles };
